/* unplugin-vue-components disabled */import script from "./MaterialDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialDialog.vue?vue&type=script&setup=true&lang=js"

import "./MaterialDialog.vue?vue&type=style&index=0&id=1df1c810&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df1c810"]])

export default __exports__